// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3zGo5","rootSmall":"AddTileButton_rootSmall__2cPLJ"};